export function getQuestionTitle(q, language) {
  if (!q) return '';
  if (language === 'en') {
    return (q.titleEn || q.titleHe || '').trim();
  }
  return (q.titleHe || q.titleEn || '').trim();
}

export function getOptionLabel(opt, language) {
  if (!opt) return '';
  if (language === 'en') {
    return (opt.labelEn || opt.labelHe || '').trim();
  }
  return (opt.labelHe || opt.labelEn || '').trim();
}

export function formatAnswerLabel(answer, question, language, getTeamDisplayName) {
  if (!answer?.answer) return '—';
  const a = answer.answer;
  if (question.type === 'team' && a.teamGroupId) {
    const team = typeof a.teamGroupId === 'object' ? a.teamGroupId : null;
    return team ? getTeamDisplayName(team, language) : '—';
  }
  if (question.type === 'text') {
    return a.text || '—';
  }
  if (question.type === 'options') {
    const opt = question.options?.find((o) => o.optionId === a.optionId);
    return opt ? getOptionLabel(opt, language) : a.optionId || '—';
  }
  return '—';
}
